import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import moment from 'moment';
import { logErroGeralAction, logFazendaSincAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import DataTable from 'react-data-table-component';
import SincIcon from '../imgs/sinc.png'
import { Link } from "react-router-dom";
import Swal from 'sweetalert2';
import {
    Button,
    Col,
    Card,
    CardBody,
    CardHeader,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from 'reactstrap';

const RelatorioLogErroGeral = (props) => {

    const [term, setTerm] = useState('');
    const [linkNgrok, setLinkNgrok] = useState('');
    const [idErro, setIdErro] = useState(0);
    const [sistema, setSistema] = useState('');

    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);

    useEffect(() => {
        dispatch(logErroGeralAction.getLogErroGeral());
    }, []);

    const handleClose = () => {
        setOpen(false)
    };

    const handleClickOpen = (idErro, sistema) => {
        setOpen(true)
        setIdErro(idErro)
        setSistema(sistema)
    };

    const handleSimulaSincronismo = () => {

        const { match: { params } } = props;
        const { dispatch } = props;

        if (linkNgrok == '' || linkNgrok == null || linkNgrok == undefined) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Informe o link do ngrok</div>'
            });
        } else if (linkNgrok.includes('ngrok') == false) {

            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left">Informe um link válido para o ngrok</div>'
            });

        } else {

            var formData = new FormData();
            formData.append('id_erro', idErro);
            formData.append('token', 'gestorrp_fortalezatec')

            if (sistema != null && sistema == 'sincronismo') {
                dispatch(logFazendaSincAction.postSincronismoZootecnico(linkNgrok, formData, true));
                setLinkNgrok('');
            } else if (sistema != null && sistema == 'sincronismo_financeiro') {
                dispatch(logFazendaSincAction.postSincronismoFinanceiro(linkNgrok, formData, true));
                setLinkNgrok('');
            } else if (sistema != null && sistema == 'sincronismo_inseminadores') {
                dispatch(logFazendaSincAction.postSincronismoInseminadores(linkNgrok, formData, true));
                setLinkNgrok('');
            }
        }
    };

    const { logErroGeral } = props.logErroGeral;

    const columns = [
        //{
        //    name: '',
        //    selector: row => (
        //        <Tooltip
        //            title="Simular Sincronismo"
        //            position="bottom"
        //        >
        //            <img src={SincIcon} alt="sinc" color="#000" style={{ width: 21, cursor: 'pointer' }} onClick={() => handleClickOpen(row.idErro, row.sistema)} />
        //        </Tooltip>
        //    ),
        //    width: '55px'
        //},
        {
            name: 'Id Erro',
            selector: row => `${row.idErro ? row.idErro : ''}`,
            width: '100px'
        },
        {
            name: 'Sistema',
            selector: row => `${row.sistema ? row.sistema == 'sincronismo' ? 'ZOOTÉCNICO' : row.sistema == 'sincronismo_financeiro' ? 'FINANCEIRO' : row.sistema == 'guardiaoXML' ? 'FINANCEIRO' : 'INSEMINADORES' : ''}`,
            sortable: true
        },
        {
            name: 'Data Cadastro',
            selector: row => `${row.dataCadastro ? moment(row.dataCadastro).format("DD/MM/YYYY HH:mm") : '-'}`,
            sortable: true
        },
        {
            name: 'Nome da Fazenda',
            selector: row => (
                <Link target="_blank" to={{ pathname: `/fazenda/${row.idFazenda}` }}>
                    {row.fazenda.toUpperCase() ? row.fazenda.toUpperCase() : ''}
                </Link>
            ),
            sortable: true,
            width: '200px'
        },
        {
            name: 'Usuário',
            selector: row => `${row.usuario.toUpperCase() ? row.usuario.toUpperCase() : ''}`,
            sortable: true,
            width: '180px'
        },
        {
            name: 'Erro',
            selector: row => (<></>),
            sortable: true,
            width: '345px'
        }
    ];

    const handleChange = prop => event => {
        setTerm(event.target.value);
    };


    return (
        <div>
            <Card>
                <CardHeader>
                    <Row>
                        <Col md={8}>
                            <h6 className="left">Erros Gerais Por Fazenda</h6>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md={6} >
                            <Input
                                id="term"
                                label="term"
                                placeholder="Filtro"
                                value={term}
                                onChange={handleChange('term')}
                            />
                        </Col>
                    </Row>
                    <br />
                    <DataTable
                        title=""
                        columns={columns}
                        pagination={true}
                        striped={true}
                        noDataComponent="Sem registros para mostrar"
                        paginationComponentOptions={{ rowsPerPageText: 'Registros por página:', rangeSeparatorText: 'de', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Tudo' }}
                        data={logErroGeral.filter((item) => {
                            if (term === "") {
                                return item;
                            } else if (item.fazenda.toLowerCase().includes(term.toLowerCase())) {
                                return item;
                            } else if (item.usuario.toLowerCase().includes(term.toLowerCase())) {
                                return item;
                            }
                        })}
                    />
                    <Row>
                        <Col className="left" md="12" lg="12">
                            <span style={{ color: '#737373' }}>* Clique sobre o nome da Fazenda para abrir a tela de edição da mesma</span>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Modal isOpen={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <ModalHeader id="form-dialog-title">Simulação de Sincronismo</ModalHeader>
                <ModalBody>
                    <p>
                        <span>Para prosseguir, digite o link do ngrok abaixo:</span>
                    </p>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label className="left" for="nome">Link *</Label>
                                <Input
                                    id="linkNgrok"
                                    label="linkNgrok"
                                    className="form-control"
                                    value={linkNgrok}
                                    onChange={(e) => setLinkNgrok(e.target.value)} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="left" md="12" lg="12">
                            <span style={{ color: '#737373' }}>O link deve ser digitado sem a barra no final e com o https. Ex: "<u>https://cc5f-177-137-253-157.ngrok-free.app</u>"</span>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleClose} color="secondary">Cancelar</Button>
                    <Button onClick={(event) => handleSimulaSincronismo(event)} color="primary">Simular sincronismo</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}


const mapStateToProps = (state) => {
    return state
};

const connectedRelatorioLogErroGeralPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(RelatorioLogErroGeral));
export { connectedRelatorioLogErroGeralPage as RelatorioLogErroGeral };